export default __webpack_public_path__ + "static/media/history-chart.dad6ccde.svg";